import { get, post } from './fetch'

export interface ExpenseType {
  code: string
  value: string
}

export interface AddExpenseTypeRule {
  userGroup: string
  add: {
    company: string
    title: string
    item: string
    code: string
  }[]
}

export function getExpenseTypes() {
  return get('expense/code/value', { cache: true }) as Promise<ExpenseType[]>
}

const RULE_URL = 'expense/code/rule'
function addExpenseTypeRuleExcludeEmpty(addExpenseRule: AddExpenseTypeRule) {
  // exclude empty
  const add = addExpenseRule.add.filter(({ company, code }) => company && code) // item, title can be empty
  if (add.length > 0) {
    return post(RULE_URL, {
      userGroup: addExpenseRule.userGroup,
      add,
      opt: { isRegexs: false },
    })
  }
}

function addExpenseTypeRuleNotExcludeEmpty(addExpenseRule: AddExpenseTypeRule) {
  return post(RULE_URL, { ...addExpenseRule, opt: { isRegexs: false } })
}

export function addExpenseTypeRule(addExpenseRule: AddExpenseTypeRule) {
  const POST_ONLY_NON_BLANK = true // 片方は未使用だが念の為実装は残している
  return (
    POST_ONLY_NON_BLANK
      ? addExpenseTypeRuleExcludeEmpty
      : addExpenseTypeRuleNotExcludeEmpty
  )(addExpenseRule)
}
